var React = require('react');

function FTDownload (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Page 1"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"transform":"translate(-262.000000, -632.000000)","fill":"#FFFFFF"},React.createElement("g",{"transform":"translate(262.000000, 632.000000)"},[React.createElement("polygon",{"id":"Fill-1","points":"5.0004 -0.0002 5.0004 8.3698 1.8584 4.8358 0.3634 6.1638 6.0004 12.5048 11.6364 6.1638 10.1404 4.8358 7.0004 8.3698 7.0004 -0.0002","key":0}),React.createElement("polygon",{"id":"Fill-2","points":"0 16 12 16 12 14 0 14","key":1})])))]);
}

FTDownload.defaultProps = {"id":"ft_download","width":"12px","height":"16px","viewBox":"0 0 12 16","version":"1.1"};

module.exports = FTDownload;

FTDownload.default = FTDownload;
